import type { AgreementAthlete, AthleteProfile } from '@/types/agreements';
import { reactive, ref, watch } from 'vue';

interface DialogState {
  isOpen: boolean;
  agreementTwrn?: string;
  athletes?: (AgreementAthlete | AthleteProfile)[];
}

const defaultState: DialogState = {
  isOpen: false,
  agreementTwrn: undefined,
  athletes: undefined,
};

const getDefaultState = () => ({ ...defaultState });

const state = reactive(getDefaultState());

function resetState() {
  Object.assign(state, getDefaultState());
}

const isRendered = ref<boolean>(false);

watch(() => state.isOpen, (isOpen) => {
  if (isOpen && !isRendered.value) isRendered.value = true;
  if (!isOpen) resetState();
});

export function useAddPaymentDialog() {
  function open(agreementTwrn?: string, athletes?: (AgreementAthlete | AthleteProfile)[]) {
    state.agreementTwrn = agreementTwrn;
    state.athletes = athletes;
    state.isOpen = true;
  }

  function close() {
    state.isOpen = false;
  }

  return {
    state,
    isRendered,
    resetState,
    open,
    close,
  };
};
